import { connect } from 'react-redux';
import { fetchAllFaqsIfNeeded } from 'help/ducks/faqs';
import Faqs from 'help/components/faqs';
import { bindActionCreators } from 'redux';

Faqs.need = [fetchAllFaqsIfNeeded];

export function mapStateToProps({ help: { faqs } }) {
  return {
    ...faqs
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAllFaqsIfNeeded,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Faqs);



// WEBPACK FOOTER //
// ./help/containers/faqs.js